import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

export const STATUSES = {
    CONNECTED: 'connected',
    DISCONNECTED: 'disconnected',
}

class ApiNationConnectionAppResource extends AppResource {
    /**
     * @returns {string}
     */
    appResourceType() {
        return 'api-nation-connection';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'api-nation-connections';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'userUuid',
            'status',
        ];
    }

    /**
     * @returns {{}}
     */
    relationMap() {
        return {};
    }

    /**
     * @returns {{}}
     */
    relationForeignKeys() {
        return {};
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {};
    }
}

export default ApiNationConnectionAppResource
